import React from 'react'
import { Select, Option } from './styles'

type Props = {
  perPage: number
  perPageOptions?: (any & IPerPageOptions)[]
  onPerPageChange: Function
}

export interface IPerPageOptions {
  label: string
  value: number
}

const SelectFooter: React.FC<Props> = (props: Props): JSX.Element => {
  return (
    <Select
      onChange={(event) => {
        const itemSelected = event.target.value
        props.onPerPageChange(itemSelected)
      }}
      defaultValue={props.perPage.toString()}
    >
      {props.perPageOptions?.map((option, key) => (
        <Option key={key} value={option.value ? option.value : option}>
          {String(option.label ? option.label : option)}
        </Option>
      ))}
    </Select>
  )
}

export default SelectFooter
